<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroNewspaper"></ng-icon>
      <h2>Clause</h2>
    </div>
    <div class="d-flex justify-content-between flex-wrap align-items-center col-md-9 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Clause</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off" #filterInput>
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Filter by Contract Type</mat-label>
          <input type="text" placeholder="Select Contract Type" matInput [matAutocomplete]="auto" [formControl]="selectedContractType"
            (input)="onInputChange($event.target.value)" #contractInput>
          <mat-icon matSuffix *ngIf="selectedContractType.value" class="clear-icon" (click)="clearField()"><ng-icon name="heroXMark"></ng-icon></mat-icon>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
            <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="dense-2 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Filter by Template</mat-label>
          <input type="text" placeholder="Select Template" matInput [matAutocomplete]="templateAuto" [formControl]="selectedTemplate"
            (input)="onInputChange($event.target.value)" #templateInput [disabled]="!templates">
          <mat-icon matSuffix *ngIf="selectedTemplate.value" class="clear-icon"
            (click)="clearTemplateField()"><ng-icon name="heroXMark"></ng-icon></mat-icon>
          <mat-autocomplete #templateAuto="matAutocomplete" (optionSelected)="onTemplateSelect($event)">
            <mat-option disabled *ngIf="templateNotFound">No Items Found</mat-option>
            <mat-option *ngFor="let option of templateOptions | async" [value]="option">
              {{option.templateName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [disabled]="!userService.permissionsValue['_CLAUSES_ADD_']"
      [routerLink]="['/app/clause/add']">
      Add Clause </button>
    </div>
  </div>
  <div class="inner-box">
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Clause Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Clause Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple [disabled]="!userService.permissionsValue['_CLAUSES_VIEW_']"
            matTooltip="View Clause {{element.name | titlecase}}" [routerLink]="['/app/clause', 'view', element.clauseId]"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">{{ element.name | titlecase }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Contract Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contract Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.contractTypeName | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Mandatory">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Mandatory</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.isMandatory === true ? 'Yes' : 'No' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Version">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.version }}</mat-cell>
      </ng-container>


      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.updatedDate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple [disabled]="!userService.permissionsValue['_CLAUSES_EDIT_']"
          [routerLink]="['/app/clause', 'edit', element.clauseId]" matTooltip="Edit Clause {{element.name | titlecase}}"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <ng-icon name="heroPencil"></ng-icon>
          </a>

        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.data.length > 0 && dataSource.filter && dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no clauses found with <strong>'{{dataSource.filter}}'</strong></p>
        <button mat-raised-button color="warn" (click)="clearField()">Reset Filters</button>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && dataSource.data.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no clauses found with selected filter!</p>
        <button mat-raised-button color="warn" (click)="clearField()">Reset Filters</button>
      </div>
    </ng-container>

    <ng-container *ngIf="dataLoading">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>


    <ng-container *ngIf="dataSource.data.length === 0 && !dataSource.filter && !dataLoading">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no clauses found.</p>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>